import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vipcabserviceinchennai() {



  const cardData =
  {
    keyword: 'VIP Cab Services in Chennai',
    heading: 'Aaryan Travels: VIP Cab Services in Chennai',
    headingDescription: 'Aaryan Travels offers premium VIP Cab Services in Chennai for business leaders, celebrities, NRI guests, and high-profile travelers who demand privacy, comfort, and punctuality. Whether you require airport transfers from Chennai International Airport, luxury rides to star hotels, or chauffeur-driven cabs for special events, our fleet of high-end sedans and SUVs—including Mercedes, BMW, and Innova Crysta—ensures a distinguished travel experience. With uniformed chauffeurs, discreet service, and on-request amenities like bottled water and Wi-Fi, we provide seamless VIP transportation across OMR, Guindy, Nungambakkam, and ECR. Aaryan Travels is the trusted choice for executive-level VIP cab services in Chennai.',

    top: 'Top Places to Visit in Chennai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is the world’s second-longest urban beach, stretching over 13 km along the Bay of Bengal. It is a popular spot for morning walks, sunset views, pony rides, and street snacks like sundal and murukku. Families and tourists flock here for its lively atmosphere. Marina Beach is Chennai’s iconic coastal escape."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a stunning Dravidian-style temple dedicated to Lord Shiva and Goddess Parvati. Its colorful gopuram, intricate carvings, and sacred pond reflect Tamil culture. Devotees and architecture lovers visit throughout the year. Kapaleeshwarar Temple is Chennai’s spiritual and cultural landmark."
  },
  {
    "title": "Fort St. George",
    "description": "Built in 1644 by the British East India Company, Fort St. George is the first English fortress in India. It now houses a museum with colonial artifacts, old maps, and weaponry. The fort also contains the Tamil Nadu Legislative Assembly. Fort St. George is Chennai’s historical gateway to the colonial past."
  },
  {
    "title": "Santhome Basilica",
    "description": "Santhome Basilica is a Gothic-style church built over the tomb of Saint Thomas the Apostle, making it one of only three churches in the world built over an apostolic tomb. The white facade and stained glass interiors create a peaceful aura. Santhome Basilica is Chennai’s sacred Christian heritage landmark."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a magnificent monument dedicated to the famous Tamil poet-saint Thiruvalluvar. Built like a temple chariot, it features inscriptions of all 1,330 couplets from the Thirukkural. The auditorium inside is one of the largest in Asia. Valluvar Kottam is Chennai’s tribute to wisdom and literature."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park is one of the smallest yet most biodiverse national parks located within a city. It houses deer, blackbucks, jackals, and various bird species. The adjacent Children's Park and Snake Park attract families. Guindy Park is Chennai’s refreshing urban wildlife sanctuary."
  },
  {
    "title": "Government Museum & National Art Gallery",
    "description": "Located in Egmore, this museum is one of India’s oldest and features rare bronze idols, archaeological artifacts, and ancient sculptures. The National Art Gallery displays stunning traditional paintings. History and art lovers spend hours exploring its vast collection. It is Chennai’s treasure chest of culture and knowledge."
  },
  {
    "title": "Elliot’s Beach (Besant Nagar Beach)",
    "description": "Elliot’s Beach offers a calmer alternative to Marina Beach, popular among youngsters and café-goers. The nearby Karl Schmidt Memorial stands as a tribute to a brave sailor. Beachfront eateries add to the lively vibe. Elliot’s Beach is Chennai’s relaxed hangout by the sea."
  },
  {
    "title": "Arignar Anna Zoological Park (Vandalur Zoo)",
    "description": "Spread across 1,300 acres, this zoo is home to tigers, lions, giraffes, and elephants. Safari rides and walk-through aviaries provide close wildlife experiences. It is ideal for family outings and educational trips. Vandalur Zoo is Chennai’s exciting wildlife adventure."
  },
  {
    "title": "Thousand Lights Mosque",
    "description": "Thousand Lights Mosque is a majestic Shia mosque known for its multi-domed architecture. Legend says a thousand oil lamps were once used to light its vast prayer hall. The mosque glows beautifully during festivals. It stands as Chennai’s symbol of Islamic heritage and unity."
  }
],



"services": [
  {
    "name": "VIP Cab Services in Chennai",
    "description": "VIP Cab Services in Chennai deliver an unmatched level of comfort, exclusivity, and professionalism for discerning travelers. Designed for executives, celebrities, and corporate leaders, this service ensures that every ride is luxurious, private, and punctual. With high-end vehicles, expertly trained chauffeurs, and 24/7 availability, it caters to airport transfers, business meetings, and special occasions. Each journey reflects sophistication and reliability, making it the preferred choice for elite travelers in Chennai."
  },
  {
    "name": "Chennai Premium Taxi",
    "description": "Chennai Premium Taxi offers first-class transportation featuring luxury vehicles and courteous chauffeurs. Ideal for business professionals, VIP guests, and tourists seeking superior comfort, this service emphasizes punctuality, safety, and personalized care. Every taxi is meticulously maintained and equipped with modern amenities to provide a smooth, stylish ride across the city."
  },
  {
    "name": "Executive Cab Hire Chennai",
    "description": "Executive Cab Hire Chennai provides top-tier cab services tailored to meet corporate and executive travel requirements. With plush interiors, professional drivers, and flexible booking options, it ensures a seamless experience for business meetings, conferences, and client visits. The service prioritizes time efficiency, privacy, and comfort for high-level professionals."
  },
  {
    "name": "Chauffeur Driven VIP Cab Chennai",
    "description": "Chauffeur Driven VIP Cab Chennai offers an exclusive range of high-end vehicles chauffeured by skilled and well-trained professionals. This service caters to CEOs, dignitaries, and high-profile guests who expect excellence in every aspect of their journey. With impeccable hospitality, attention to detail, and an emphasis on discretion, it guarantees a world-class travel experience."
  },
  {
    "name": "Luxury Car Services Chennai",
    "description": "Luxury Car Services Chennai provide access to an exceptional fleet of premium sedans, SUVs, and luxury models. Suitable for weddings, business travel, and private events, this service focuses on creating memorable rides through comfort, style, and superior customer care. From pick-up to drop-off, every detail is managed to perfection."
  },
  {
    "name": "Corporate VIP Cabs Chennai",
    "description": "Corporate VIP Cabs Chennai is dedicated to offering businesses elegant and reliable transport solutions for executives, clients, and guests. Featuring luxury vehicles with experienced chauffeurs, this service supports corporate branding through professionalism, punctuality, and class. Long-term and short-term contracts are available for maximum flexibility."
  },
  {
    "name": "Best VIP Taxi Chennai",
    "description": "Best VIP Taxi Chennai stands out for its blend of premium comfort, reliability, and outstanding service quality. Designed for those who expect more from their travel, it provides fully air-conditioned luxury cars, courteous chauffeurs, and real-time ride tracking for safety and convenience."
  },
  {
    "name": "Affordable VIP Cab Chennai",
    "description": "Affordable VIP Cab Chennai delivers high-end travel experiences at competitive rates. This service makes luxury accessible for business professionals and private clients, offering well-maintained vehicles, trained drivers, and flexible booking packages without compromising on quality or comfort."
  },
  {
    "name": "VIP Sedan Rental Chennai",
    "description": "VIP Sedan Rental Chennai offers an elite range of luxury sedans perfect for business trips, city tours, and executive commutes. Each vehicle features refined interiors, modern technology, and trained chauffeurs who ensure a smooth, comfortable, and distinguished ride."
  },
  {
    "name": "High-End Cab Hire Chennai",
    "description": "High-End Cab Hire Chennai focuses on providing superior travel solutions with premium vehicles and impeccable service. Ideal for corporate executives, foreign delegates, and special events, this service guarantees elegance, safety, and punctuality in every journey."
  },
  {
    "name": "Online VIP Cab Booking Chennai",
    "description": "Online VIP Cab Booking Chennai enables customers to book luxury cabs easily through an intuitive online platform. The system allows for instant booking confirmations, route customization, and 24/7 customer support, ensuring a hassle-free premium cab experience across Chennai."
  },
  {
    "name": "Wedding VIP Cab Chennai",
    "description": "Wedding VIP Cab Chennai specializes in providing elegant vehicles for weddings, receptions, and guest transport. With beautifully decorated luxury cars, courteous chauffeurs, and attention to timing, it ensures a touch of class and glamour on your special day."
  },
  {
    "name": "Elite Cab Service Chennai",
    "description": "Elite Cab Service Chennai caters to the city's most distinguished travelers, offering personalized transport solutions with world-class Mercedes, BMW, and Audi vehicles. Designed for both business and leisure, it combines speed, sophistication, and reliability in every trip."
  },
  {
    "name": "Prestige Transport Chennai",
    "description": "Prestige Transport Chennai stands for excellence in premium mobility. With high-end sedans and SUVs, uniformed chauffeurs, and a focus on comfort and style, this service provides a superior experience for executives, VIPs, and travelers who value quality and discretion."
  },
  {
    "name": "VIP Vehicle Rental Chennai",
    "description": "VIP Vehicle Rental Chennai provides long-term and short-term luxury vehicle rental options for corporate and personal use. The fleet includes top-of-the-line models, all maintained to perfection, with dedicated chauffeurs ensuring seamless travel throughout Chennai."
  }
],
"tableData": [
  ["VIP Cab Services in Chennai", "Chennai Premium Taxi"],
  ["Executive Cab Hire Chennai", "Chauffeur Driven VIP Cab Chennai"],
  ["Luxury Car Services Chennai", "Corporate VIP Cabs Chennai"],
  ["Best VIP Taxi Chennai", "Affordable VIP Cab Chennai"],
  ["VIP Sedan Rental Chennai", "High-End Cab Hire Chennai"],
  ["Online VIP Cab Booking Chennai", "Wedding VIP Cab Chennai"],
  ["Elite Cab Service Chennai", "Prestige Transport Chennai"],
  ["VIP Vehicle Rental Chennai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "VIP Cab Services in Chennai",
    "WhyChoosedescription": "Aaryan Travels offers exclusive VIP cab services in Chennai, ensuring premium comfort, privacy, and professionalism for every journey."
  },
  {
    "WhyChooseheading": "Luxury Vehicles for VIP Travel",
    "WhyChoosedescription": "Travel in top-of-the-line cars including sedans and SUVs, ideal for executives, celebrities, and high-profile clients."
  },
  {
    "WhyChooseheading": "Highly Trained Chauffeurs",
    "WhyChoosedescription": "Our professional drivers are trained in VIP protocol, offering discreet, courteous, and punctual service."
  },
  {
    "WhyChooseheading": "Sanitized and Immaculately Maintained Cabs",
    "WhyChoosedescription": "All VIP vehicles are cleaned thoroughly and maintained to the highest standards of hygiene and safety."
  },
  {
    "WhyChooseheading": "Flat-Rate Transparent Billing",
    "WhyChoosedescription": "Enjoy peace of mind with upfront pricing that includes fuel, tolls, and driver fees—no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Personalized Customer Support",
    "WhyChoosedescription": "Our dedicated VIP support team is available round-the-clock to assist with bookings and special arrangements."
  },
  {
    "WhyChooseheading": "Custom Travel Plans for VIP Clients",
    "WhyChoosedescription": "We offer flexible hourly, daily, and long-term rental packages tailored to your specific travel needs and preferences."
  },
  {
    "WhyChooseheading": "Discreet and Secure Travel Experience",
    "WhyChoosedescription": "Enjoy privacy, security, and a smooth travel experience with our trusted and professional VIP services in Chennai."
  }
]



























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer VIP cab services in Chennai?',
    answer: 'Yes, Aaryan Travels provides exclusive VIP cab services in Chennai, designed for luxury, comfort, and top-tier service.',
  },
  {
    question: 'How can I book VIP cab services in Chennai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Chennai.',
  },
  {
    question: 'What types of vehicles are available under VIP cab services in Chennai?',
    answer: 'Aaryan Travels offers a fleet of luxury cars including Mercedes, BMW, and high-end SUVs as part of its VIP cab service in Chennai.',
  },
  {
    question: 'Are drivers professionally trained for VIP cab services in Chennai?',
    answer: 'Absolutely. Our VIP cab drivers are professionally trained, well-groomed, and discreet, ensuring a premium experience.',
  },
  {
    question: 'Can VIP cabs be booked for special events and business travel in Chennai?',
    answer: 'Yes, Aaryan Travels’ VIP cab services are ideal for business travel, celebrity transport, weddings, and other special occasions.',
  },
  {
    question: 'Is the VIP cab service in Chennai available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock VIP cab services in Chennai to suit your schedule and convenience.',
  },
  {
    question: 'Are hygiene and safety standards followed in VIP cab services?',
    answer: 'All VIP vehicles are sanitized thoroughly before every trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for VIP cab services in Chennai?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during my VIP cab booking in Chennai?',
    answer: 'Yes, our dedicated 24x7 customer support team is available throughout your ride for any assistance required.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Surya Narayanan',
    feedback: 'Aaryan Travels delivered a true VIP experience in Chennai. Luxurious cab, courteous chauffeur, and perfect timing.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anitha Raj',
    feedback: 'Excellent VIP cab service by Aaryan Travels in Chennai. The ride was smooth, clean, and professional throughout.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const vipCabChennaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "VIP Cab Services in Chennai",
  "description": "Aaryan Travels provides VIP cab services in Chennai with premium vehicles, executive chauffeurs, and luxury comfort for business travel, weddings, and special occasions. Book affordable VIP cabs online today.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "serviceType": "VIP Cab Services",
  "keywords": "VIP Cab Services in Chennai, Chennai Premium Taxi, Executive Cab Hire Chennai, Chauffeur Driven VIP Cab Chennai, Luxury Car Services Chennai, Corporate VIP Cabs Chennai, Best VIP Taxi Chennai, Affordable VIP Cab Chennai, VIP Sedan Rental Chennai, High-End Cab Hire Chennai, Online VIP Cab Booking Chennai, Wedding VIP Cab Chennai, Elite Cab Service Chennai, Prestige Transport Chennai, VIP Vehicle Rental Chennai"
};







  return (
    <div>
<Helmet>
  <title>VIP Cab Services in Chennai | Luxury & Executive Car Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book VIP cab services in Chennai with Aaryan Travels. Experience premium cars, professional chauffeurs, and luxury rides for corporate, wedding, and personal travel needs."
  />
  <meta
    name="keywords"
    content="VIP Cab Services in Chennai, Chennai Premium Taxi, Executive Cab Hire Chennai, Chauffeur Driven VIP Cab Chennai, Luxury Car Services Chennai, Corporate VIP Cabs Chennai, Best VIP Taxi Chennai, Affordable VIP Cab Chennai, VIP Sedan Rental Chennai, High-End Cab Hire Chennai, Online VIP Cab Booking Chennai, Wedding VIP Cab Chennai, Elite Cab Service Chennai, Prestige Transport Chennai, VIP Vehicle Rental Chennai"
  />
  <script type="application/ld+json">
    {JSON.stringify(vipCabChennaiSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vipcabserviceinchennai;